<template ref="header">
  <header class="AppHeader-root" :class="{'hide':!!showHeader}" @mouseleave="changeProductState(2)">
    <div class="head g-box">
      <div class="lt">
        <img alt="澄信信息科技" class="logo" src="../../assets/logo2.png" @click="changeCurrent(nav[0])">
      </div>
      <ul class="nav-ul">
        <li v-for="(item,index) in nav" :key="index" class="li" :class="{ 'current':currentNav==item.id}" @click="changeCurrent(item)" @mousemove="changeProductState(item.id)">
          <p class="text">{{ item.title }}</p>
        </li>
      </ul>
    </div>
    <ul class="product-ul" v-if="showProduct" @mouseleave="changeProductState(2)">
      <li class="product-li" v-for="(item,index) in productList" :key="index">
        <h4 class="h4" @click="jumpToHref(item.id)">{{ item.title }}</h4>
        <ul class="list" v-for="(v,i) in item.list" :key="i">
          <li class="li" @click="jumpToHref(item.id,v.id)">{{ v.name }}</li>
        </ul>
      </li>
    </ul>
  </header>
</template>
<script>
  export default {
    name       : 'AppHeader',
    components : {},
    props      : {
      currentNav : {
        type    : Number,
        default : 0,
      },
      productList : {
        type    : Array,
        default : []
      },
    },
    data(){
      return {
        nav : [
          {id:0,title : '首页', url : 'index.html'},
          {id:1,title : '产品方案', url : ''},
          {id:2,title : '开发报价', url : 'quotation.html'},
          {id:3,title : '成功案例', url : 'real_project.html'},
          {id:4,title : '关于澄信', url : 'about_us.html'},
        ],
        showProduct:false,
        showHeader:false,
      };
    },
    computed   : {},
    created(){
      // this.orientationPage();
    },
    methods    : {
      orientationPage(){ // 定位nav的current
        this.nav.map((item, index) => {
          if (location.href.indexOf(item.url) > -1) {
            this.current = index;
          }
        });
      },
      changeCurrent(itemData){// 切换页面
        this.current = itemData.id;
        if(itemData.url){
          location.href = this.$api.domainName + itemData.url;
        }
      },
      changeProductState(id){
        if(id == 1){
          this.showProduct = true
        } else{
          this.showProduct = false
        }
      },
      jumpToHref(id=0,cid=0){
        location.href = this.$api.domainName + 'products.html' + '?id=' + id + '&cid=' + cid;
      },
      hideHead(){
        // 页面滚动距顶部距离
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
            document.body.scrollTop
        var scroll = scrollTop - this.i; // 正数为向下滚，负数为向上滚
        this.i = scrollTop;
        if(scrollTop > 144){
          if (scroll < 0) {
            this.showHeader = false;
            return false
          } else {
            this.showHeader = true;
            return true
          }
        }
      },
    },
  };
</script>
<style scoped lang="scss">
  .AppHeader-root{
    flex-shrink: 0;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 1000;
    transition: all 1s ease-out;
    &.hide{
      transform: translateY(-100%);
      transition: all 1s ease-out;
    }
    .head{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .lt, .logo{
        height: 50Px;
        @extend %btn_base;
      }
    }
    .nav-ul{
      display: flex;
      align-items: center;
      font-size: 18Px;
      .li{
        padding: 0 16Px;
        height: 4em;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 2Px solid transparent;
        &.current, &:hover{
          color: #007bc1;
          border-color: #007bc1;
        }
        .text{
          @extend %btn_base;
          min-width: 4em;
          text-align: center;
        }
      }
    }
    .product-ul{
      position: fixed;
      top: 72Px;
      left: 0;
      background: #1c1f2e;
      color:#fff;
      font-size: 18px;
      display: flex;
      justify-content: center;
      padding-bottom: 30px;
      width: 100%;
      .product-li{
        &:not(:first-child){
          margin-left: 76px;
        }
      }
      .h4{
        font-size: 16px;
        padding: 38px 0 18px;
        @extend %btn_base;
      }
      .list{
        font-size: 14px;
        .li{
          margin-bottom: 12px;
          @extend %btn_base;
          &:hover{
            color:$primary-color
          }
        }
      }
    }
  }
</style>
